import { createChunkLoader } from 'utils/chunkLoader';

/**
 * The chunk loaders of the candidate pages the router mounts lazily
 * (routeMounts.tsx). They live apart from the mounts so the interview boot (preloadCandidateRouteChunk.ts) and a page
 * warming its next step can start a page's download without loading the app.
 * Each page has one memoized loader, so the router and every warm-up share one
 * import: Vite's preload helper waits for a chunk's stylesheets only in the
 * first import that requests them, so a second, separate import could render
 * the page before its styles arrive.
 */
const shared = <T>(importChunk: () => Promise<T>): (() => Promise<T>) =>
  createChunkLoader(importChunk).load;

export const loadWebCall = shared(() => import('pages/web-call/WebCallPage'));

export const loadInterviewRejoin = shared(
  () => import('pages/web-call/InterviewRejoinPage')
);
export const loadInterviewScheduling = shared(
  () => import('pages/web-call/InterviewSchedulingPage')
);
export const loadFeedback = shared(() => import('pages/web-call/FeedbackPage'));
export const loadFeedbackSuccess = shared(
  () => import('pages/web-call/FeedbackSuccessPage')
);
export const loadRescheduleReason = shared(
  () => import('pages/web-call/RescheduleReasonPage')
);
export const loadRescheduleInterview = shared(
  () => import('pages/web-call/RescheduleInterviewPage')
);
export const loadWebCallError = shared(
  () => import('pages/web-call/WebCallErrorPage')
);
export const loadInterviewCompleted = shared(
  () => import('pages/web-call/InterviewCompletedPage')
);
export const loadVideoPermissionHelp = shared(
  () => import('pages/web-call/VideoPermissionHelpPage')
);
export const loadScreenSharePermissionHelp = shared(
  () => import('pages/web-call/ScreenSharePermissionHelpPage')
);
export const loadOptOutSuccess = shared(
  () => import('pages/web-call/OptOutSuccessPage')
);
export const loadPracticeCompletion = shared(
  () => import('pages/web-call/PracticeCompletionPage')
);
export const loadReviewAction = shared(
  () => import('pages/rejection-review/ReviewActionPage')
);
export const loadResumeFeedbackDetails = shared(
  () => import('pages/resume-feedback-details/ResumeFeedbackDetailsPage')
);
export const loadWithdrawal = shared(
  () => import('pages/withdrawal/WithdrawalPage')
);
export const loadUninterested = shared(
  () => import('pages/uninterested/UninterestedPage')
);
export const loadAlternativeRole = shared(
  () => import('pages/alternative-role/AlternativeRolePage')
);
export const loadPreapplyOptOut = shared(
  () => import('pages/preapply-opt-out/PreapplyOptOutPage')
);
export const loadHMIntake = shared(
  () => import('pages/hm-intake/HMIntakePage')
);
